import collateralRecord from '@/api/credit-operation/collateral-record'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    collateralAssets: [],
    loans: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_COLLATERAL_ASSETS (state, data) {
        state.collateralAssets = data
    },
    SET_LOANS (state, data) {
        state.loans = data
    }
}

export const actions = {
    fetch (context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        )
        return collateralRecord.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store (context, data) {
        return collateralRecord.store(data)
    },
    update (context, { id, data }) {
        return collateralRecord.update(id, data)
    },
    destroy (context, id) {
        return collateralRecord.destroy(id)
    },
    withdraw (context, { id, data }) {
        return collateralRecord.withdraw(id, data)
    },
    async getCollateralAssets (context, attributes = {}) {
        let response = await collateralRecord.collateralAssets({
            params: attributes
        })
        context.commit('SET_COLLATERAL_ASSETS', response.data)
    },
    async getLoans (context, attributes = {}) {
        let response = await collateralRecord.loans({ params: attributes })
        context.commit('SET_LOANS', response.data)
    }
}
